var React = require('react');

function PhoneRotate (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41 14a1 1 0 01-1-1c-.007-6.072-4.928-10.993-11-11a1 1 0 010-2c7.177.008 12.992 5.823 13 13a1 1 0 01-1 1zM13 42C5.824 41.992.008 36.176 0 29a1 1 0 012 0c.007 6.072 4.928 10.993 11 11a1 1 0 010 2zm27.539-13.758a4.983 4.983 0 000-7.047L20.811 1.456a4.99 4.99 0 00-7.05 0l-12.3 12.3a4.99 4.99 0 000 7.05l19.728 19.738a4.994 4.994 0 007.05 0l12.3-12.302zm-2.987-5.794L22.445 37.555a1 1 0 01-1.415 0L3.447 19.967a1 1 0 010-1.414L18.556 3.444a1 1 0 011.414 0l17.582 17.59a1 1 0 010 1.414z","fill":"#53647F"}));
}

PhoneRotate.defaultProps = {"width":"42","height":"42"};

module.exports = PhoneRotate;

PhoneRotate.default = PhoneRotate;
